/**
 * Copyright Highway9 Networks Inc.
 */

import { ServiceInstance, AvailableUpgrade } from "~/types/serviceInstance";
import { IpsecVmcAllocation } from "~/types/edgeMetrics";
import APIService from "./APIServices";
import { PayloadLocationType, PayloadServiceInstanceStatus, Summary } from "~/types/summary";
import { ServiceInstanceRelease } from "~/types/SoftwareReleases";
import { RadioManager } from "~/types/RadioManager";

const serviceInstanceAPI = new APIService<ServiceInstance>("serviceInstances");
const ipsecVmcAllocationAPI = new APIService<IpsecVmcAllocation>("serviceInstances");
const radioManagerAPI = new APIService<RadioManager>("radioManager");


export const serviceInstanceService = {
    getServiceInstances: serviceInstanceAPI.getAll,
    deleteServiceInstance,
    upgradeServiceInstance,
    retryServiceInstance,
    updateServiceInstance,
    getSaasSummary,
    createReleaseCopy,
    getReleases,
    updateRelease,
    deleteRelease,
    getMetrics,
    getIpsecVmcAllocations,
    getVMCReleases,
    getServiceInstanceReleases,
    getRadioManagers : radioManagerAPI.getAll,
    updateRadioManager : radioManagerAPI.update,
};

function updateServiceInstance(id: string, body: any) {
    return serviceInstanceAPI.update(body, id);
}

function upgradeServiceInstance(id: string, body: any) {
    console.log("Upgrading service instance with id " + id);
    return serviceInstanceAPI.post(`${id}/operations/upgrade`, body);
}

function deleteServiceInstance(id: string, isForced: boolean) {
    console.log("Deleting service instance with id " + id);
    return serviceInstanceAPI.delete(id, { isForceDelete: isForced });
}

function retryServiceInstance(id: string) {
    console.log("Retrying service instance with id " + id);
    return serviceInstanceAPI.post(`${id}/operations/retry`);
}


async function getSaasSummary({
    locationType = [],
    serviceInstanceStatus = [],
    serviceType = [],
    tenantId,
}: {
    locationType?: PayloadLocationType[];
    serviceInstanceStatus?: PayloadServiceInstanceStatus[];
    serviceType?: string[];
    tenantId?: string;
}) {
    const summaryAPI = new APIService<Summary>("summary");
    // APIService.post expects only 1 type argument, should just pass the body as-is
    // also, argument to post: (endpoint: string, body?: unknown)
    const body = {
        locationType,
        serviceInstanceStatus,
        serviceType,
        tenantId,
    };
    return summaryAPI.post("query", body) ;
}

const releaseAPI = new APIService<ServiceInstanceRelease>("serviceInstances/releases");

function updateRelease(id: string, body: any) {
    return releaseAPI.update(body, id);
}

function createReleaseCopy(body: any) {
    return releaseAPI.create(body);
}

async function getReleases() {
    return releaseAPI.getAll();
}

async function getVMCReleases(payload ?: { filter: { tenantId?: string } }) {

    const res = await releaseAPI.post<ServiceInstanceRelease[]>("query", payload as any);
    return res as unknown as ServiceInstanceRelease[];
}

function deleteRelease(id: string) {
    return releaseAPI.delete(id);
}
async function getMetrics(query: any) {
    const metricsAPI = new APIService<any>("edges/metrics");
    return metricsAPI.post("aggregate", query);
}

async function getIpsecVmcAllocations() {
    return ipsecVmcAllocationAPI.getAll();
}

async function getServiceInstanceReleases(serviceInstanceId: string): Promise<AvailableUpgrade[]> {
    try {
        return serviceInstanceAPI.get<AvailableUpgrade[]>(`${serviceInstanceId}/releases`);
    } catch (error) {
        console.error(error);
        throw error;
    }
}
